angular.module('picmonicng').factory('Modal', function () {
  return {
    activeContent: null,
    show: function (contentSelector, options) {
      this.activeContent = contentSelector;

      $('#mainModal').modal(options);
    },
    hide: function () {
      this.activeContent = null;
      $('#mainModal').modal('hide');
    },
  };
});
